import MobileSupport from "./MobileSupport";

export default function Support() {
  return <> {window.innerWidth <= 480 ? <MobileSupport /> : ""}</>;
}
